import React, { Component, Fragment } from 'react'
import { Input, Icon, ToolTip } from '@drifthq/tide-core'
import PasswordHints from 'layouts/PasswordHints'
import * as passUtils from 'utils/password'

class PasswordInput extends Component {
  constructor(props) {
    super(props)
    this.state = {toggleShowPassword: false}
  }

  onClick = () => {
    this.setState({
      toggleShowPassword: !this.state.toggleShowPassword
    })
  }

  render() {
    const {
      value,
      placeholder = 'Password',
      onChange,
      size = 'medium',
      label = 'What’s your password?',
      className,
      passwordConfig,
      passwordConfigFetched
    } = this.props

    const {
      toggleShowPassword
    } = this.state

    const passwordDisplay = toggleShowPassword ? "text" : "password"
    const passwordTooltipText = toggleShowPassword ? "Hide Password" : "Show Password"

    return (
      <Fragment>
        <div className="password-input-wrapper">
          <Input
            label={label}
            placeholder={placeholder}
            value={value}
            type={passwordDisplay}
            size={size}
            className="password-input"
            onChange={onChange}
          />
          <div className="password-input-preview" onClick={this.onClick}>
            <ToolTip className="password-input-tooltip" flow="up" render={() => `${passwordTooltipText}`}>
              <Icon name={toggleShowPassword ? "eye-off" : "eye"} />
            </ToolTip>
          </div>
        </div>

        {passwordConfigFetched && <PasswordHints
          hasMinCharacters={passUtils.hasMinCharacters(value, passwordConfig)}
          hasMinUniqueCharacters={passUtils.hasMinUniqueCharacters(value, passwordConfig)}
          hasSpecialCharacter={passUtils.hasSpecialCharacter(value, passwordConfig)}
          hasMixedCase={passUtils.hasMixedCase(value, passwordConfig)}
          hasNumber={passUtils.hasNumber(value, passwordConfig)}
          meetsAllRequirements={passUtils.meetsAllRequirements(value, passwordConfig)}
          passwordConfig={passwordConfig}
          className={className}
          onChange={onChange}
        />}
      </Fragment>
    )
  }
}
export default PasswordInput



// WEBPACK FOOTER //
// ./src/components/PasswordInput/index.js